export enum ContractsFiltersTypes {

    Piid = 'contractNumber',
    Naics = 'naics',
    PscCode = 'pscCode',
    Keywords = 'keywords',
    SignedDate = 'signedDate',
    StartDate = 'startDate',
    Agency = 'agency',
    CompletionDate = 'completionDate',
    PopCity = 'popCity',
    PopState = 'popState',
    SubcontractPlan = 'subcontractingDescription',
    SolicitationProcedures = 'solicitationProcedures',
    NationalInterestActionCode = 'nationalInterestCode',
    SetAside = 'setAside',
    ModZero = 'modificationNumber',
    ContractingOfficerEmail = 'contractingOfficerEmail'

}